<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">{{options?.title}}</h4>
</div>

<div class="modal-body">
  <p>{{options?.body}}</p>
  <input class="form-control" type="file" [attr.accept]="options?.fileFilter" [attr.multiple]="options?.allowMultiple ? true : null" autofocus
    (change)="getFiles($event)" />
  @if (tooLargeFiles) {
    <p class="error mb-0">Files not added. The maximum combined file size allowed in one upload is {{getReadableFileSize(this.options.maxFileSize)}}.</p>
  }
  @if (tooManyfiles) {
    <p class="error mb-0">Files not added. The maximum number of files allowed in one upload is {{this.options.maxFiles}}.</p>
  }
  @if (files?.length > 0) {
    <br />
    <h5>{{files.length}} selected files:</h5>
    <table style="width: 100%">
      <tr class="border-bottom">
        <th width="80%">Filename</th>
        <th class="right" width="20%">Size</th>
      </tr>
      @for (file of files; track file; let odd = $odd) {
        <tr [class.odd]="odd">
          <td>{{file.name}}</td>
          <td class="right">{{getReadableFileSize(file.size)}}</td>
        </tr>
      }
    </table>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="ok()" [disabled]="$safeNavigationMigration(files?.length) < 1">{{options?.okButtonText || 'Ok'}}</button>
  <button type="button" class="btn btn-link" (click)="close()">{{options?.cancelButtonText || 'Cancel'}}</button>
</div>
